
interface FavoriteButtonProps {
  isFavorite: boolean;
  onToggle: () => void;
  size?: 'xs' | 'sm' | 'md';
}

export default function FavoriteButton({ isFavorite, onToggle, size = 'md' }: FavoriteButtonProps) {
  const sizeClasses = size === 'xs'
    ? 'w-4 h-4 text-[8px] rounded'
    : size === 'sm' 
      ? 'w-5 h-5 text-[10px] rounded' 
      : 'w-11 h-11 text-xl rounded-xl';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={`${sizeClasses} flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0 ${
        isFavorite 
          ? 'bg-terracotta text-white shadow-md shadow-terracotta/25 scale-110' 
          : 'bg-cream text-dark/40 hover:bg-rose-soft hover:text-terracotta'
      }`}
      title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
    >
      <i className={isFavorite ? 'ri-heart-3-fill' : 'ri-heart-3-line'}></i>
    </button>
  );
}
